var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('usage-history',{attrs:{"data":_vm.usageHistoryList}})}
var staticRenderFns = []

export { render, staticRenderFns }